var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0743 10.5372C21.0743 4.727 16.3474 0 10.5372 0C4.72693 0 0 4.72693 0 10.5372C0 15.706 3.741 20.0173 8.65763 20.9062V21.9512H6.50265C5.46461 21.9512 4.62311 22.7927 4.62311 23.8307C4.62311 24.8687 5.46461 25.7103 6.50265 25.7103H8.65763V26.1203C8.65763 27.1584 9.49912 27.9999 10.5372 27.9999C11.5752 27.9999 12.4167 27.1584 12.4167 26.1203V25.7103H14.5717C15.6097 25.7103 16.4512 24.8687 16.4512 23.8307C16.4512 22.7927 15.6097 21.9512 14.5717 21.9512H12.4167V20.9062C17.3333 20.0173 21.0743 15.706 21.0743 10.5372ZM3.75908 10.5372C3.75908 6.79973 6.79972 3.75915 10.5372 3.75915C14.2746 3.75915 17.3152 6.79979 17.3152 10.5372C17.3152 14.2745 14.2745 17.3152 10.5372 17.3152C6.79972 17.3152 3.75908 14.2746 3.75908 10.5372Z",
    fill: "url(#paint0_linear_968_278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.0745 10.5372C21.0745 4.72727 16.3472 0 10.5372 0C7.97603 0 5.62506 0.919021 3.79661 2.4441C2.83102 3.24944 2.0113 4.22462 1.38332 5.32238C0.503338 6.86115 0 8.64167 0 10.5372C0 12.4335 0.503338 14.214 1.38332 15.7521C2.70639 14.6523 3.60623 13.0601 3.79729 11.259C3.77196 11.0221 3.75894 10.781 3.75894 10.5372C3.75894 10.2934 3.77196 10.0524 3.79729 9.81544C3.98836 8.01438 4.8882 6.42219 6.21126 5.32238C7.38572 4.34652 8.89437 3.75895 10.5372 3.75895C14.2743 3.75895 17.3148 6.79952 17.3148 10.5372C17.3148 14.275 14.2743 17.3155 10.5372 17.3155C8.89437 17.3155 7.38572 16.728 6.21126 15.7521C5.58329 16.8499 4.76357 17.825 3.79798 18.6304C5.16829 19.774 6.8317 20.5759 8.65742 20.906V21.951H6.50231C5.46482 21.951 4.62318 22.7927 4.62318 23.8308C4.62318 24.869 5.46482 25.7107 6.50231 25.7107H8.65742V26.1202C8.65742 27.1584 9.49906 28 10.5372 28C11.5754 28 12.4164 27.1584 12.4164 26.1202V25.7107H14.5715C15.6097 25.7107 16.4513 24.869 16.4513 23.8308C16.4513 22.7927 15.6097 21.951 14.5715 21.951H12.4164V20.906C17.3333 20.0171 21.0745 15.7062 21.0745 10.5372Z",
    fill: "url(#paint1_linear_968_278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.79785 18.6302C4.25401 19.0109 4.74331 19.3528 5.25966 19.653C5.26192 19.6543 5.26452 19.6555 5.26678 19.6568C5.80093 19.1842 6.28578 18.6569 6.71447 18.0858C7.1103 17.5585 7.73964 17.2592 8.39775 17.3017C8.54087 17.3106 8.68469 17.3154 8.82987 17.3154C9.12023 17.3154 9.40579 17.2969 9.68657 17.2613C9.68629 17.2613 9.68602 17.2611 9.68582 17.2611C8.37522 17.0962 7.17946 16.5565 6.21114 15.752C5.58316 16.8497 4.76337 17.8249 3.79785 18.6302Z",
    fill: "url(#paint2_linear_968_278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.80087 11.2292C3.70294 12.1907 3.40299 13.094 2.94416 13.8945C2.34906 12.8557 2.02104 11.6442 2.05459 10.3561C2.08472 9.20698 2.40522 8.12497 2.94622 7.18267C3.592 6.05615 4.55211 5.12891 5.7067 4.52422C6.53875 4.08936 7.47147 3.8216 8.46034 3.76887C8.87808 3.74627 9.2876 3.76202 9.68684 3.81269C8.37679 3.9791 7.18179 4.52079 6.21415 5.32613C4.88561 6.43142 3.98508 8.0332 3.80087 9.84454V9.84522C3.7769 10.0726 3.76526 10.3034 3.76526 10.5369C3.76526 10.7704 3.7769 11.0012 3.80087 11.2285V11.2292Z",
    fill: "url(#paint3_linear_968_278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.0747 10.5372C21.0747 4.72727 16.3474 0 10.5374 0C10.0732 0 9.61609 0.0306114 9.16754 0.0890945C14.3323 0.763089 18.3341 5.19171 18.3341 10.5372C18.3341 15.5459 14.8214 19.7489 10.13 20.8135C9.86571 20.8735 9.67595 21.1048 9.67595 21.3758C9.67595 21.6935 9.9335 21.951 10.2512 21.951H11.792C12.8162 21.951 13.682 22.7541 13.7102 23.778C13.7394 24.8403 12.8868 25.7107 11.8311 25.7107H10.0855C9.85934 25.7107 9.67601 25.894 9.67601 26.1202C9.67601 26.6178 9.48249 27.0699 9.16699 27.4061C9.51063 27.7722 9.99897 28.001 10.541 28C11.584 27.9981 12.4166 27.1238 12.4166 26.0809V25.7107H14.5326C15.5569 25.7107 16.4227 24.9076 16.4509 23.8837C16.4801 22.8214 15.6275 21.951 14.5718 21.951H12.4167V20.906C17.3335 20.0171 21.0747 15.7062 21.0747 10.5372Z",
    fill: "url(#paint4_linear_968_278)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_968_278",
    x1: -3.11091,
    y1: 14,
    x2: 22.0201,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#FE73C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1239A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_968_278",
    x1: -3.11091,
    y1: 14,
    x2: 22.0203,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#FE73C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1239A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_968_278",
    x1: -0.140103,
    y1: 17.7044,
    x2: 11.3035,
    y2: 17.7044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#FE73C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1239A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_968_278",
    x1: -3.05316,
    y1: 8.82663,
    x2: 11.7832,
    y2: 8.82663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#FE73C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1239A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_968_278",
    x1: -5.63006,
    y1: 14,
    x2: 18.7561,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5725,
    stopColor: "#FE73C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1239A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.52fa31b42bb1b1f26f5449ba69d6b7fe.svg";
export { ForwardRef as ReactComponent };